// Unpublished Work © 2023 Deere & Company.

import {
    SET_LOG_HISTORY_DATA,
    UPDATE_LOG_HISTORY_LOADING_STATUS
} from '../../action-list';
import {PageStatus} from '../../state/struct/page-status';
import {LogHistory} from '../../state/struct/profile/log-history';

const updateLogHistoryLoadingStatus = (state, action) =>
    LogHistory.update(state, {
        logHistoryStatus: {
            $set: action.status
        }
    });

const setLogHistoryData = (state, action) =>
    LogHistory({
        addressLogs: action.logHistoryDetails.addressLogs,
        taxIdLogs: action.logHistoryDetails.taxIdLogs,
        mergeLogs: action.logHistoryDetails.mergeLogs,
        busnToContLogs: action.logHistoryDetails.busnToContLogs,
        phoneFaxLogs: action.logHistoryDetails.phoneFaxLogs,
        emailLogs: action.logHistoryDetails.emailLogs,
        customerConsentLogs: action.logHistoryDetails.customerConsentLogs,
        survivorConsentLogs: action.logHistoryDetails.survivorConsentLogs,
        individualNameLogs: action.logHistoryDetails.indivNameLogs,
        businessNameLogs: action.logHistoryDetails.busnNameLogs,
        entityLogs: action.logHistoryDetails.entityLogs,
        businessContactLogs: action.logHistoryDetails.businessContactLogs,
        customerName: action.logHistoryDetails.customerName,
        customerType: action.logHistoryDetails.customerType,
        logHistoryStatus: PageStatus.meta.map.COMPLETE
    });

export function logHistory(state = new LogHistory({}), action = {}) {
    const actionHandlers = {
        [SET_LOG_HISTORY_DATA]: setLogHistoryData,
        [UPDATE_LOG_HISTORY_LOADING_STATUS]: updateLogHistoryLoadingStatus
    };

    const reducer = actionHandlers[action.type];

    return reducer ? reducer(state, action) : state;
}
